export default "__VITE_ASSET__DebNUEyy__"